// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3q2iL","label":"Radio_label__3844e","checkMark":"Radio_checkMark__23ttT","disabled":"Radio_disabled__2Sech"};